import { StripePrice } from 'redux/bulkEnquiryLodgement/types';

export interface PaymentTypePriceResponse {
  paymentType: string;
  currency: string;
  taxBehavior: string;
  unitAmount: number;
  unitAmountDecimal: string;
}

export function mapPaymentTypePriceToStripePrice(
  response: PaymentTypePriceResponse
): StripePrice {
  const currency = response.currency.toUpperCase();
  const dollars = (response.unitAmount / 100).toFixed(2);
  return {
    amount: response.unitAmount,
    currency: response.currency,
    formatted: `$${dollars} ${currency}`,
    formattedWithTax:
      response.taxBehavior === 'inclusive'
        ? `$${dollars} ${currency} (inc. GST)`
        : undefined,
    stripeProductId: null
  };
}
